import api from "../../index.js";

export const GetIBTreeApi = (userId) => api.get(`ibusermaster/get-ibtree/${userId}`);